import {
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
} from "components/table";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "components/loading/LoadingSpinner";
import { PaginationController } from "components/PaginationController/PaginationController";
import { OrganisationOnixUploadFileReportDialogTableRow } from "./OrganisationOnixUploadFileReportDialogTableRow";

export interface UploadReportProduct {
  isbn: string;
  title?: string;
  author?: string[];
  productGroupDescription?: string;
  failed?: boolean;
  publishedAt?: string;
  chunkFileName: string;
  chunkId: string;
  errors: string[];
}

interface OrganisationOnixUploadFileReportDialogTableProps {
  loading?: boolean;
  products: UploadReportProduct[];
  itemsCount: number;
}

export const OrganisationOnixUploadFileReportDialogTable = ({
  loading,
  products,
  itemsCount,
}: OrganisationOnixUploadFileReportDialogTableProps) => {
  const { t } = useTranslation(["settings"]);

  const columnWidths = {
    isbn: "15%",
    author: "15%",
    title: "25%",
    productForm: "15%",
    publishedOn: "15%",
    qualityCheck: "18%",
  };

  return (
    <div className="flex flex-col h-[47vh]">
      <div
        className="relative w-full rounded-xl border border-secondary-200 text-sm flex-1 overflow-hidden"
        role="region"
      >
        <table className="w-full caption-bottom text-sm text-secondary-600 table-fixed">
          <colgroup>
            <col style={{ width: columnWidths.isbn }} />
            <col style={{ width: columnWidths.author }} />
            <col style={{ width: columnWidths.title }} />
            <col style={{ width: columnWidths.productForm }} />
            <col style={{ width: columnWidths.publishedOn }} />
            <col style={{ width: columnWidths.qualityCheck }} />
          </colgroup>
          <TableHeader>
            <TableRow>
              <TableHead className="truncate">
                {t("settings:organisation.onix.table.isbn")}
              </TableHead>
              <TableHead className="truncate">
                {t("settings:organisation.onix.table.author")}
              </TableHead>
              <TableHead className="truncate">
                {t("settings:organisation.onix.table.title")}
              </TableHead>
              <TableHead className="truncate">
                {t("settings:organisation.onix.table.productForm")}
              </TableHead>
              <TableHead className="truncate">
                {t("settings:organisation.onix.table.publishedOn")}
              </TableHead>
              <TableHead className="truncate">
                {t("settings:organisation.onix.table.qualityCheck")}
              </TableHead>
            </TableRow>
          </TableHeader>
        </table>
        <div
          className="overflow-y-auto"
          style={{ height: "calc(100% - 40px)" }}
        >
          <table className="w-full caption-bottom text-sm text-secondary-600 table-fixed">
            <colgroup>
              <col style={{ width: columnWidths.isbn }} />
              <col style={{ width: columnWidths.author }} />
              <col style={{ width: columnWidths.title }} />
              <col style={{ width: columnWidths.productForm }} />
              <col style={{ width: columnWidths.publishedOn }} />
              <col style={{ width: columnWidths.qualityCheck }} />
            </colgroup>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={6}>
                    <div className="flex items-center justify-center w-full pt-10">
                      <LoadingSpinner />
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                products.map((product) => (
                  <OrganisationOnixUploadFileReportDialogTableRow
                    key={product.chunkId}
                    product={product}
                  />
                ))
              )}
            </TableBody>
          </table>
        </div>
      </div>
      <div className="mt-4">
        <PaginationController
          itemsCount={itemsCount}
          pageSizeLabel={t("settings:organisation.onix.report.perPage")}
          prefix="report"
        />
      </div>
    </div>
  );
};
